export const formatCount = value => value == null ? '해당 없음' : value.toLocaleString('ko-KR')
export const formatSourceLabel = source => source.entrySource === 'animal_detail' && source.label === '동물런 상세 배너'
    ? '애니멀런 상세 배너' : source.label
export const formatRate = value => value == null ? '—' : `${(value * 100).toLocaleString('ko-KR', { maximumFractionDigits: 2 })}%`
export const formatUpdatedAt = value => value ? new Date(value).toLocaleString('ko-KR', { timeZone: 'Asia/Seoul', hour12: false }) : '—'

export const buildMembershipParams = ({ range = '7d', platform = 'ALL', entrySource = 'ALL', from, to }, orders = false) => ({
    range,
    platform,
    ...(!orders ? { entrySource } : {}),
    ...(range === 'custom' ? { from, to } : {}),
})

const dateValue = value => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return NaN
    const timestamp = Date.parse(`${value}T00:00:00Z`)
    return Number.isFinite(timestamp) && new Date(timestamp).toISOString().slice(0, 10) === value ? timestamp : NaN
}

export const validateCustomRange = (from, to, maxDays = 90) => {
    const start = dateValue(from)
    const end = dateValue(to)
    if (!Number.isFinite(start) || !Number.isFinite(end)) return '유효한 시작일과 종료일을 입력해 주세요.'
    if (start > end) return '시작일은 종료일보다 늦을 수 없습니다.'
    if ((end - start) / 86400000 + 1 > maxDays) return `직접 지정은 시작일과 종료일을 포함해 최대 ${maxDays}일입니다.`
    return ''
}

export const getAvailability = (meta, platform, entrySource) => entrySource === undefined
    ? meta?.availability.orderSegments.find(row => row.platform === platform)
    : meta?.availability.summary.find(row => row.platform === platform && row.entrySource === entrySource)

export const getRangeIssue = (availability, query) => {
    if (!availability || availability.status !== 'ready') return '이 조건의 분석 데이터가 아직 준비되지 않았습니다.'
    if (query.range === 'custom' && (query.from < availability.availableFrom || query.to > availability.dataThrough)) {
        return `선택한 기간이 제공 범위를 벗어났습니다. 제공 가능 기간: ${availability.availableFrom} ~ ${availability.dataThrough}`
    }
    return ''
}

export const describeError = error => {
    const response = error?.response
    const data = response?.data
    if (response?.status === 401 || response?.status === 403 || data?.code === 403) return '멤버십 분석 조회 권한을 확인해 주세요.'
    if (data?.code === 'DATA_NOT_AVAILABLE') {
        const range = data.details?.availableFrom && data.details?.dataThrough
            ? ` 제공 가능 기간: ${data.details.availableFrom} ~ ${data.details.dataThrough}` : ''
        return `${data.message || '분석 데이터가 아직 준비되지 않았습니다.'}${range}`
    }
    if (['INVALID_FILTER', 'INVALID_DATE_RANGE'].includes(data?.code)) return data.message || '조회 조건을 확인해 주세요.'
    return '멤버십 분석 데이터를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.'
}

export const WARNING_LABELS = {
    INVALID_EVENT: '필수 분석 정보 오류', UNREGISTERED_SOURCE: '미등록 진입점',
    CONFLICTING_JOURNEY: '진입 흐름 정보 충돌', UNLINKED_EVENT: '앞 단계와 연결되지 않은 이벤트',
    DUPLICATE_TRANSACTION: '중복 구매 이벤트', ORDER_MISSING_PAYMENT_TIME: '결제 시각 누락 주문',
    ORDER_CLASSIFICATION_UNKNOWN: '멤버십 이력 미분류 주문', DATA_REFRESH_DELAYED: '집계 갱신 지연',
}
export const WARNING_UNITS = { event: '건', journey: '흐름', order: '주문', day: '일' }
